import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { AssetDataOverviewPage } from "@/modules/asset_data/OverviewPage";
import { AssetDataWindowPage } from "@/modules/asset_data/WindowPage";
import { AssetDataHistoryPage } from "@/modules/asset_data/HistoryPage";
import { AssetDataControlPage } from "@/modules/asset_data/ControlPage";

/** Asset Data — decoded telemetry Orbit is receiving now, live and historic.
 *
 *  `base` MUST match the route App.tsx mounts this module on (/asset-data).
 *  It said "/live" from the 2026-09-22 rename until 2026-09-23: the rail entry
 *  and the App route both moved, the SubNav base did not, so every tab linked
 *  to /live/<tab>, matched nothing, and fell through to the catch-all redirect
 *  home. Overview appeared to work only because the module's own relative
 *  path="*" redirect lands on /asset-data/overview without going via `base`. */
export function AssetDataModule() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav
          base="/asset-data"
          tabs={[
            { path: "overview", label: "Overview" },
            { path: "window", label: "Live Window" },
            { path: "history", label: "History" },
            { path: "control", label: "Asset Control" },
          ]}
        />
        <div style={{ marginLeft: "auto", paddingBottom: 9, paddingRight: 20 }}>
        </div>
      </div>
      <Routes>
        <Route path="overview" element={<AssetDataOverviewPage />} />
        <Route path="window" element={<AssetDataWindowPage />} />
        <Route path="history" element={<AssetDataHistoryPage />} />
        <Route path="control" element={<AssetDataControlPage />} />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </>
  );
}
